export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "articles_in_section": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["このセクションの記事"])}
    }
  })
}
